import { Button, Form, message, Radio, Select } from 'antd'
import React, {useEffect, useState} from 'react'
import DatePickerYearMonth from '../../../components/DatePicker/YearMonth'
import moment from 'moment';
import {postFrom} from "../../../axios";
import {API_merchant_findAll} from "../../../axios/config";

const AccountingRecordReportSearch = (props) => {
    const [merchantList, setMerchantList] = useState([]);
    useEffect(() => {
        postMerchantList()
    }, [])
    const handleDateTypeChange = (e) => {
        const dateType = e.target.value
        const clear = {
            year: undefined,
            month: undefined,
            startDate: undefined,
            endDate: undefined,
            isJh: undefined
        }
        if (dateType === 2) {
            clear.month = moment().subtract(1, 'month').format('YYYY-MM')  //默认查上月
        }
        props.onChange({
            ...props.value, 
            ...clear,
            dateType
        })
    }

    const handleMonthChange = (e) => {
        props.onChange({...props.value, month: e.format('YYYY-MM')})
    }

    const postMerchantList = () => {
        postFrom({
            url: API_merchant_findAll,
            data: {},
        })
            .then((res) => {
                setMerchantList(res)
            })
            .catch((err) => {
                message.error(err.message || "获取商户列表失败");
            });
    }

    const handleIsJhChange = (e) => {
        console.log(e)
        props.onChange({...props.value, isJh: e})
    }

    const handleMerchantChange = (e) => {
        console.log(e)
        props.onChange({...props.value, merchantIds: e})
    }

    const handleSearch = () => {
        if (props.value.startDate && props.value.endDate && moment(props.value.startDate).add(1, 'month').isBefore(props.value.endDate)) {
            message.warning('按天查询最多支持一个月')
            return
        }
        props.onSearch()
    }

    //收款账单状态
     const isJh = [
        { title: '全部', value: 0 },
        { title: '建行', value: 1 },
        { title: '宝生', value: 2 },
    ]

    const type = [
        { title: '月', value: 2 },
    ]

    const renderData = (type) => {
        return (
            <Form.Item>
                <DatePickerYearMonth value={props.value.month} format="YYYY-MM" onChange={handleMonthChange}
                                     mode="month" placeholder="选择月份"/>
            </Form.Item>
        )

    }

    return (
        <div style={{display: 'flex', justifyContent: 'space-between' }}>
            <Form layout="inline" >
                <Form.Item>
                    <Radio.Group value={props.value.dateType} onChange={handleDateTypeChange} buttonStyle="solid">
                        {type.map(e => <Radio.Button value={e.value}>{e.title}</Radio.Button> )}
                    </Radio.Group>
                </Form.Item>
                { renderData(props.value.dateType) }
                <Form.Item>
                    <Select
                        value={props.value.isJh}
                        style={{width: 360}}
                        placeholder="请选择是否建行"
                        onChange={handleIsJhChange}
                    >
                        {isJh.map(e => <Select.Option value={e.value} key={e.value}>{e.title}</Select.Option>)}
                    </Select>
                </Form.Item>
                <Form.Item>
                    <Select
                        value={props.value.merchantIds}
                        mode="multiple"
                        style={{width: 360}}
                        placeholder="选择商户"
                        onChange={handleMerchantChange}
                    >

                        {merchantList.map(e => <Select.Option value={e.id} key={e.id}>{e.shortName}</Select.Option>)}
                    </Select>
                </Form.Item>
                <Form.Item>
                    <Button type="primary" onClick={handleSearch}>查询</Button>
                </Form.Item>
            </Form>
            <div style={{paddingTop:4}}>
                {props.children}
            </div>
        </div>
    )
}

export default AccountingRecordReportSearch


// WEBPACK FOOTER //
// ./src/page/ProjectMonitoringStatistics/components/SearchView.jsx